import routes from "./aapi2Routes";
import raw from "./rawClients/rawAapi2Client";
import Admin2Client from "./generated/aapi2/client";
const NAME = "aapi2Client";
const getTotalCountFromResponse = res => res.total_count;
const concatPageData = pages =>
  pages.reduce((acc, page) => acc.concat(page.data), []);
const entities = {
  NAME,
  orgAdmins: {
    getAll: orgId =>
      raw
        .getAll(`${routes.orgAdmins.all(orgId)}?include_profile=true`, {
          getTotalCountFromResponse,
        })
        .then(concatPageData),
  },
  orgProject: {
    get: (orgId, projectId) =>
      raw.get(routes.orgProjects.one(orgId, projectId)),
    removeFromOrg: projectId =>
      raw.delete(routes.orgProjects.removeFromOrg(projectId)),
  },
  orgProjects: {
    getAll: orgId =>
      raw
        .get(`${routes.orgProjects.all(orgId)}?with_details=true`)
        .then(response => response.data),
    restore: (orgId, project_ids) =>
      raw.put(routes.orgProjects.restore(orgId), { project_ids }),
    archive: (orgId, projectDetails) =>
      raw.post(routes.orgProjects.archive(orgId), {
        data: projectDetails,
      }),
  },
  orgProjectProfile: {
    update: (orgId, projectId, profile) =>
      raw.put(routes.orgProjects.profile(orgId, projectId), profile),
  },
  orgProjectRoles: {
    getAll: (orgId, projectId) =>
      raw
        .getAll(routes.orgProjectRoles.all(orgId, projectId), {
          getTotalCountFromResponse,
        })
        .then(concatPageData),
  },
  orgProjectUsers: {
    add: (orgId, projectId, emails, role) =>
      raw.post(routes.orgProjectUsers.batch(orgId, projectId), {
        emails,
        role,
      }),
    getAll: (orgId, projectId) =>
      raw
        .getAll(routes.orgProjectUsers.all(orgId, projectId), {
          getTotalCountFromResponse,
        })
        .then(concatPageData),
    removeFromProject: (orgId, projectId, userIds) =>
      raw.post(routes.orgProjectUsers.delete(orgId, projectId), {
        user_ids: userIds,
      }),
    update: (orgId, projectId, userIds, { roleId }) =>
      raw.patch(routes.orgProjectUsers.batch(orgId, projectId), {
        user_ids: userIds,
        role: roleId,
      }),
  },
  orgUsers: {
    batchUpdate: (orgId, data) =>
      raw.patch(routes.orgUsers.batch(orgId), { data }),
    expireSessions: userId => raw.post(routes.orgUsers.expireSessions(userId)),
    getAll: orgId =>
      raw
        .getAll(
          `${routes.orgUsers.all(
            orgId
          )}?include_license=true&include_profile=true`,
          {
            getTotalCountFromResponse,
          }
        )
        .then(concatPageData),
    update: (orgId, userId, data) =>
      raw.patch(routes.orgUsers.one(orgId, userId), data),
  },
  orgEntitlements: {
    getAll: orgId => raw.get(routes.orgEntitlements.all(orgId)),
  },
  orgFeatureFlags: {
    getAll: orgId => raw.get(routes.orgFeatureFlags.all(orgId)),
  },
  orgUserProjects: {
    getOrgUserProjects: userId =>
      raw
        .getAll(routes.orgUserProjects.all(userId), {
          getTotalCountFromResponse,
        })
        .then(total_count => {
          return { data: concatPageData(total_count) };
        }),
  },
  removeUserProjects: {
    removeProjects: (userId, project_ids) =>
      raw.post(routes.orgUserProjects.delete(userId), { project_ids }),
  },
};
const client = new Admin2Client(raw);
const aapi2Client = {};
Object.getOwnPropertyNames(Admin2Client.prototype).forEach(name => {
  if (name === "constructor") {
    return;
  }
  aapi2Client[name] = client[name].bind(client);
});
Object.assign(aapi2Client, entities);
// ensure `NAME` is readonly.
Object.defineProperty(aapi2Client, "NAME", {
  get: () => NAME,
});
export default aapi2Client;
